<div id="pause" class="d-flex align-items-center justify-content-center" *ngIf="showSpinner">
    <span class="loader"></span>
</div>